function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

export function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

window.pauseAllMedia = function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
};

export function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

window.debounce = function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

export function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  if (this.countryEl) {
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
    this.initCountry();
  }

  if (this.provinceEl) {
    this.initProvince();
  }
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.sentinelObserver = null;
    this.gridObserver = null;
    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  connectedCallback() {
    const buttonElement = document.querySelector('#Details-menu-drawer-container');
    document.addEventListener('search-button-clicked', (event) => {
      this.closeAnimation(buttonElement);
      document.querySelector('#shopify-section-header').classList.remove('menu-open');
    });

    this.#handleFilterIconVisibility();
  }

  disconnectedCallback() {
    if (this.sentinelObserver) this.sentinelObserver.disconnect();
    if (this.gridObserver) this.gridObserver.disconnect();
  }

  #handleFilterIconVisibility() {
    const elementId = this.dataset.filterIconId;
    const filterIconElem = this.querySelector(`#${elementId}`);
    if (!(filterIconElem instanceof HTMLElement)) return;

    document.body.classList.add('has-filter-icon-mobile');

    const scrollThreshold = 770;

    // Create sentinel inside the parent container
    let sentinel = this.querySelector('.scroll-sentinel');
    this.style.position = 'relative';
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.classList.add('scroll-sentinel');
      sentinel.textContent = 'sentinel';
      sentinel.style.top = `${scrollThreshold}px`;
      this.prepend(sentinel);
    }

    let isIconVisible = false;
    const sentinelObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          filterIconElem.classList.add('filter-icon-mobile--visible');
          isIconVisible = true;
        } else {
          const rect = entry.boundingClientRect;
          if (rect.top > 0) {
            filterIconElem.classList.remove('filter-icon-mobile--visible');
            isIconVisible = false;
          } 
          else {
            filterIconElem.classList.add('filter-icon-mobile--visible');
            isIconVisible = true;
          }
        }
      });
      }, {
        threshold: 0,
        rootMargin: '0px' // trigger exactly when the element enters the viewport
      }
    );

    sentinelObserver.observe(sentinel);
    this.sentinelObserver = sentinelObserver;

    const productGrid = this.closest('.section-main-collection-product-grid');
    if(productGrid) {
      const gridObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            // If product grid is not visible and we're below it (footer section)
            filterIconElem.classList.remove('filter-icon-mobile--visible');
          } else if (entry.isIntersecting && isIconVisible) {
            // The icon should be visible when scrolling from footer back to product grid and hidden when scrolling to the top
            filterIconElem.classList.add('filter-icon-mobile--visible');
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px' // trigger exactly when the element enters the viewport
      });

      gridObserver.observe(productGrid);
      this.gridObserver = gridObserver;
    }
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement?.nextElementSibling?.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');  
      document.body.classList.add('overflow-hidden', 'drawer-open');
    });
    if (!summaryElement) return;
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    if (summaryElement.classList.contains('mobile-facets__open-wrapper')) return;
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    document.body.classList.remove('overflow-hidden', 'drawer-open');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.filtersElementMobile = document.querySelector('.facet-main__wrapper-mobile');
    this.filtersElementDesktop = document.querySelector('.facet-main__wrapper-desktop');
    this.filterElementSearch = document.getElementById('main-collection-filters');
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    if (this.header.querySelector('sticky-header')) {
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.querySelector('sticky-header').getBoundingClientRect().bottom - this.borderOffset)}px`);
    } else {
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    }
    this.header.classList.add('menu-open');

    if (this.filtersElementDesktop) this.filtersElementDesktop.classList.add('display_none');
    if (this.filtersElementMobile) this.filtersElementMobile.classList.add('display_none');
    if (this.filterElementSearch) this.filterElementSearch.classList.add('display_none');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    this.querySelector('menu-drawer-mobile')?.setFeatured();
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');

    if (this.filtersElementDesktop) this.filtersElementDesktop.classList.remove('display_none');
    if (this.filtersElementMobile) this.filtersElementMobile.classList.remove('display_none');
    if (this.filterElementSearch) this.filterElementSearch.classList.remove('display_none');
  }
}

customElements.define('header-drawer', HeaderDrawer);

export class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    let button = this.querySelector('button');

    if (!button) {
      button = this;
    }
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));

      if (modal) {
        if (typeof modal.show === 'function') modal.show(button);
        else if (typeof modal.open === 'function') modal.open(button);
      }
    });
  }
}

customElements.define('modal-opener', ModalOpener);

export class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if (!HTMLMediaElement.prototype.hasOwnProperty('playing')) {
      Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
        get: function () {
          return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
        },
      });
    }

    this.loadContentEvent();
  }

  loadContentEvent() {
    this.autoPlay = this.dataset.autoPlay;
    if (this.autoPlay == 'true') {
      this.loadContent(this);
    } else {
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent(focus = true) {
    if (!this.autoPlay == 'true') {
      window.pauseAllMedia();
      this.removeAttribute('loaded');
    }
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
    if (this.getAttribute('loaded') && !this.querySelector('video').playing) {
      this.querySelector('video').play();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

const VIDEO_POSTER_MQ = '(max-width: 749px)';

function applyResponsiveVideoPoster(video) {
  if (video.closest('.video-block')?.querySelector('.video-block__poster')) return;

  const { posterMobile, posterDesktop } = video.dataset;
  if (!posterMobile || !posterDesktop || posterMobile === posterDesktop) return;

  const apply = () => {
    video.poster = window.matchMedia(VIDEO_POSTER_MQ).matches ? posterMobile : posterDesktop;
  };

  apply();

  if (video.dataset.posterBound) return;
  video.dataset.posterBound = 'true';
  window.matchMedia(VIDEO_POSTER_MQ).addEventListener('change', apply);
}

function hideVideoBlockPoster(block) {
  block?.classList.add('video-block--playing');
}

function bindVideoBlockPoster(block) {
  const video = block.querySelector('.video-block__inner video');
  if (!video) return;

  applyResponsiveVideoPoster(video);

  if (block.dataset.posterPlayBound) return;
  block.dataset.posterPlayBound = 'true';

  const hidePoster = () => hideVideoBlockPoster(block);
  video.addEventListener('playing', hidePoster);
  video.addEventListener('ended', hidePoster);
  if (video.readyState >= 2 && !video.paused) hidePoster();
}

function playVideoInBlock(block) {
  const video = block.querySelector('.video-block__inner video');
  if (!video) return Promise.resolve();

  applyResponsiveVideoPoster(video);
  video.muted = true;
  video.setAttribute('muted', '');

  const tryPlay = () =>
    video
      .play()
      .then(() => hideVideoBlockPoster(block))
      .catch(() => {});

  if (video.readyState >= 2) {
    return tryPlay();
  }

  return new Promise((resolve) => {
    let played = false;
    const attempt = () => {
      if (played) return;
      played = true;
      tryPlay().then(resolve);
    };

    video.addEventListener('canplay', attempt, { once: true });
    video.addEventListener('loadeddata', attempt, { once: true });

    if (video.readyState >= 1) {
      queueMicrotask(() => {
        if (video.readyState >= 2) attempt();
      });
    }

    if (video.networkState !== HTMLMediaElement.NETWORK_LOADING && video.querySelector('source')) {
      video.load();
    }
  });
}

function playVideosInSlide(slide) {
  if (!slide) return;
  const blocks = slide.querySelectorAll('.video-block');
  return Promise.all([...blocks].map((block) => playVideoInBlock(block)));
}

function activateVideoSources(video) {
  video?.querySelectorAll('source[data-src]').forEach((source) => {
    const url = source.getAttribute('data-src');
    if (url && !source.src) source.src = url;
  });
}

function videoViewportMatches(block) {
  const viewport = block.dataset.videoViewport;
  if (!viewport || viewport === 'all') return true;
  const isMobile = window.matchMedia(VIDEO_POSTER_MQ).matches;
  return viewport === 'mobile' ? isMobile : !isMobile;
}

function activateDeferredImage(img) {
  if (!img) return;
  const src = img.getAttribute('data-deferred-src');
  const srcset = img.getAttribute('data-deferred-srcset');
  if (src && !img.src) img.src = src;
  if (srcset && !img.srcset) img.srcset = srcset;
}

function mountDeferredViewportImage(block) {
  if (block.hasAttribute('data-loaded')) {
    return block.querySelector('img');
  }

  const template = block.querySelector('template');
  if (!template?.content?.firstElementChild) return null;

  const img = template.content.firstElementChild.cloneNode(true);
  activateDeferredImage(img);
  block.appendChild(img);
  block.setAttribute('data-loaded', '');
  return img;
}

function mountDeferredVideoBlock(block) {
  if (block.hasAttribute('data-loaded')) {
    return block.querySelector('.video-block__inner video');
  }

  const template = block.querySelector('template');
  const inner = block.querySelector('.video-block__inner');
  if (!template?.content?.firstElementChild || !inner) return null;

  const video = template.content.firstElementChild.cloneNode(true);
  activateVideoSources(video);
  inner.appendChild(video);
  block.setAttribute('data-loaded', '');
  bindVideoBlockPoster(block);
  video.load();
  return video;
}

function tryActivateLazyVideoBlock(block) {
  if (!block || block.hasAttribute('data-loaded')) return false;
  if (!videoViewportMatches(block)) return false;

  if (block.hasAttribute('data-viewport-media')) {
    mountDeferredViewportImage(block);
    return true;
  }

  mountDeferredVideoBlock(block);
  playVideoInBlock(block);
  return true;
}

let lazyVideoObserver;
const lazyVideoObservedBlocks = new WeakSet();
let lazyVideoViewportListenerBound = false;
const lazyVideoPendingViewport = new Set();

function getLazyVideoObserver() {
  if (lazyVideoObserver) return lazyVideoObserver;

  lazyVideoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const block = entry.target;
        if (tryActivateLazyVideoBlock(block)) {
          lazyVideoObserver.unobserve(block);
          lazyVideoObservedBlocks.delete(block);
          lazyVideoPendingViewport.delete(block);
          return;
        }

        if (block.dataset.videoViewport) {
          lazyVideoPendingViewport.add(block);
          lazyVideoObserver.unobserve(block);
          lazyVideoObservedBlocks.delete(block);
        }
      });
    },
    { rootMargin: '200px 0px', threshold: 0.01 }
  );

  return lazyVideoObserver;
}

function bindLazyVideoViewportListener() {
  if (lazyVideoViewportListenerBound) return;
  lazyVideoViewportListenerBound = true;

  window.matchMedia(VIDEO_POSTER_MQ).addEventListener('change', () => {
    // Re-scan lazy video blocks when viewport mode changes (desktop <-> mobile).
    // This ensures hidden-at-load mobile blocks are observed once they become visible.
    initLazyVideoBlocks(document);
    lazyVideoPendingViewport.forEach((block) => {
      if (tryActivateLazyVideoBlock(block)) lazyVideoPendingViewport.delete(block);
    });
  });
}

function initLazyVideoBlocks(root = document) {
  const blocks = [
    ...root.querySelectorAll(
      '[data-lazy-intersection][data-deferred-video]:not([data-loaded]), [data-lazy-intersection][data-viewport-media]:not([data-loaded])'
    ),
  ].filter((block) => !block.closest('slideshow-component'));

  if (!blocks.length) return;

  bindLazyVideoViewportListener();

  if (typeof IntersectionObserver === 'undefined') {
    blocks.forEach((block) => tryActivateLazyVideoBlock(block));
    return;
  }

  const observer = getLazyVideoObserver();

  blocks.forEach((block) => {
    if (lazyVideoObservedBlocks.has(block)) return;
    observer.observe(block);
    lazyVideoObservedBlocks.add(block);
  });
}

function initVideoBlocks(root = document) {
  root.querySelectorAll('.video-block:not([data-deferred-video])').forEach(bindVideoBlockPoster);
  initLazyVideoBlocks(root);
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderDots = this.querySelector('[id^="GalleryThumbnails-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.modelSizeLabelMobile = document.querySelector('.model-size__label.d-block.d-md-none');
    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton?.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.cardContent = this.sliderItemsToShow[0].querySelector('.card-wrapper > .card > .card__content');
    this.sliderButtons = this.slider.parentNode.querySelector('.slider-buttons');

    if (this.cardContent && this.sliderButtons) {
      this.sliderButtons.style.top = `calc(50% - ${this.cardContent.clientHeight / 2}px)`;
    }

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.modelSizeLabelMobile) {
      if (this.currentPage !== 1) this.modelSizeLabelMobile.classList.add('visually-hidden');
      else this.modelSizeLabelMobile.classList.remove('visually-hidden');
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton?.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton?.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton?.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton?.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    this.slideshowSlides = this.slider?.querySelectorAll('.slideshow__slide') ?? [];

    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    const videoHandledByInline = window.__slideshowVideoLoaderActive === 'inline';

    if (this.sliderControlWrapper) {
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    }

    this.slider?.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (!videoHandledByInline) {
      this.addEventListener('slideChanged', this.onSlideChanged.bind(this));
      this.observeSlideMedia();
      const firstSlide = this.getSlideshowSlide(0);
      this.loadDeferredVideos(firstSlide);
      playVideosInSlide(firstSlide);
      window.__slideshowVideoLoaderActive = 'bundle';
    }

    if (this.slider?.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  getSlideshowSlide(index) {
    return this.slideshowSlides[index] ?? this.sliderItemsToShow[index];
  }

  observeSlideMedia() {
    if (!this.slider || typeof IntersectionObserver === 'undefined') return;

    this.slideMediaObserver?.disconnect();
    this.slideMediaObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.loadDeferredVideos(entry.target);
          this.slideMediaObserver.unobserve(entry.target);
        });
      },
      { root: this.slider, threshold: 0.25 }
    );

    this.slideshowSlides.forEach((slide, index) => {
      if (index === 0) return;
      if (slide.querySelector('[data-deferred-video]')) {
        this.slideMediaObserver.observe(slide);
      }
    });
  }

  onSlideChanged(event) {
    const slide = this.getSlideshowSlide(this.currentPage - 1) ?? event.detail.currentElement;

    this.pauseInactiveSlideVideos();
    this.loadDeferredVideos(slide);

    const nextSlide = this.getSlideshowSlide(this.currentPage);
    if (nextSlide && nextSlide !== slide) this.loadDeferredVideos(nextSlide);

    requestAnimationFrame(() => playVideosInSlide(slide));
  }

  loadSlideMedia(slide) {
    if (!slide) return;
    this.loadDeferredVideos(slide);
    this.loadDeferredImages(slide);
  }

  loadDeferredVideos(slide) {
    if (!slide) return;
    slide.querySelectorAll('[data-deferred-video]:not([data-loaded])').forEach((block) => {
      mountDeferredVideoBlock(block);
    });
  }

  loadDeferredImages(slide) {
    slide.querySelectorAll('picture[data-deferred-picture]:not([data-loaded])').forEach((picture) => {
      picture.querySelectorAll('source[data-deferred-srcset]').forEach((source) => {
        source.srcset = source.dataset.deferredSrcset;
      });

      const img = picture.querySelector('img[data-deferred-src]');
      if (img?.dataset.deferredSrc) img.src = img.dataset.deferredSrc;

      picture.setAttribute('data-loaded', '');
    });

    slide.querySelectorAll('img[data-deferred-src]:not([data-loaded])').forEach((img) => {
      if (img.closest('picture[data-deferred-picture]')) return;
      if (img.dataset.deferredSrc) img.src = img.dataset.deferredSrc;
      if (img.dataset.deferredSrcset) img.srcset = img.dataset.deferredSrcset;
      img.setAttribute('data-loaded', '');
    });
  }

  pauseInactiveSlideVideos() {
    this.slideshowSlides.forEach((slide, index) => {
      if (index === this.currentPage - 1) return;
      slide.querySelectorAll('.video-block').forEach((block) => {
        block.classList.remove('video-block--playing');
        block.querySelectorAll('video').forEach((video) => video.pause());
      });
    });
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton?.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1]?.classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1]?.setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    // MODIFIED: Added a flag to track the initial state when no URL params are present.
    this.initialLoadNoParams = true;
    this.inits();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  connectedCallback() {
    this.getChosenSize();
  }

  inits() {
    this.inventoryNote = document.querySelector('.inventoryNote');

    if (document.querySelector('#option-map')) {
      this.optionMap = JSON.parse(document.querySelector('#option-map').textContent);
    }

    this.updateInventoryNote();
  }

  getChosenSize() {
    // In quick-add modals, variant-selects elements have data-original-section set.
     if (this.dataset && this.dataset.originalSection) {
      return;
    }

    const params = new URLSearchParams(document.location.search);
    const size = decodeURIComponent(params.get('size'));

    // MODIFIED: If URL params for size exist, disable the special initial behavior.
    if (size && size !== 'null') {
      this.initialLoadNoParams = false;
    }

    let isBraProduct = false;

    if (document.querySelector('[data-bra-options]')) {
      isBraProduct = true;
    }

    if (isBraProduct) {
      this.querySelectorAll('[data-size]').forEach((sizeInput) => {
        if (sizeInput.dataset.size.replace(/\D/g, '') == size.replace(/\D/g, '')) {
          sizeInput.click();
        }
      });
      this.querySelectorAll('[data-cup]').forEach((sizeInput) => {
        if (sizeInput.dataset.cup.replace(/[0-9]/g, '') == size.replace(/[0-9]/g, '')) {
          sizeInput.click();
        }
      });
    } else {
      this.querySelectorAll('[data-size]').forEach((sizeInput) => {
        if (sizeInput.dataset.size == size) {
          sizeInput.click();
        }
      });
    }

    this.onVariantChange();
    if (size && size != 'null') this.updateColorSwatches(size);
  }

  updateInventoryNote() {
    // MODIFIED: If it's the initial load with no params, clear the inventory message and stop.
    const targetBtn = document.querySelector('.product-form__submit.pick-size');
    if (this.initialLoadNoParams) {
      if (this.inventoryNote) {
        this.inventoryNote.textContent = '';
        this.inventoryNote.appendChild(document.createTextNode('\u00A0'));
      }

      if (targetBtn) {
        targetBtn.classList.remove('hidden');
      }

      return;
    }

    if (this.inventoryNote && typeof variantStock !== 'undefined') {
      this.updateOptions();
      this.updateMasterId();

      if (typeof variantStock !== 'undefined') {
        this.currentVariantQuantity = variantStock.find(({ id }) => id === this.currentVariant.id).inventory_quantity;
      } else {
        this.currentVariantQuantity = 0;
      }

      this.lowInventoryThreshold = this.inventoryNote.dataset.lowInventoryThreshold;

      if (this.currentVariantQuantity <= this.lowInventoryThreshold && this.lowInventoryThreshold > 0 && this.currentVariantQuantity > 0) {
        this.lowInventoryHtml = window.variantStrings.lowInventoryHtml.replace('[quantity]', this.currentVariantQuantity);
        if (this.lowInventoryHtml) this.inventoryNote.textContent = this.lowInventoryHtml;
      } else {
        this.inventoryNote.textContent = '';
        this.inventoryNote.appendChild(document.createTextNode('\u00A0'));
      }
    }
  }

  updateLowStockNotice() {
    if (typeof connectedProductVariantData === 'undefined') return;
    const sizeLabels = document.querySelectorAll('.product__info-wrapper label[data-size]');
    const colorLabels = document.querySelectorAll('.product__info-wrapper label[data-color]');
    const lowStockThreshold = 15;

    function updateLabel(label, inventory) {
      label.classList.toggle('sold-out-label', inventory <= 0);
      label.classList.toggle('low-stock-label', inventory > 0 && inventory < lowStockThreshold);
      label.setAttribute('data-inventory', inventory);
    }

    // aggregate inventory of each size/color combination
    connectedProductVariantData.forEach((v) => {
      const existingVariant = connectedProductVariantData.find((existingV) => v['color'] === existingV['color'] && v['size'] === existingV['size']);
      if (existingVariant) {
        //existingVariant.inventory_quantity += v.inventory_quantity;
      }
    });
    // remove duplicates based on matches on color and size
    connectedProductVariantData = connectedProductVariantData.filter((v, index, self) => {
      return self.findIndex((t) => t.color === v.color && t.size === v.size) === index;
    });

    // find inventory of each size in current color
    sizeLabels.forEach((label) => {
      const variant = connectedProductVariantData.find((v) => {
        if (colorLabels.length > 1) {
          const isColor = v['color'].replaceAll(' ', '-').toLowerCase() == this.options[0]?.replaceAll(' ', '-').toLowerCase() || v['color'].replaceAll(' ', '-').toLowerCase() == this.options[1]?.replaceAll(' ', '-').toLowerCase() || v['color'].replaceAll(' ', '-').toLowerCase() == this.options[2]?.replaceAll(' ', '-').toLowerCase();
          const isSize = v['size'].toLowerCase() == label.dataset.size.toLowerCase();
          return isColor && isSize;
        } else {
          const isSize = v['size'].toLowerCase() == label.dataset.size.toLowerCase();
          return isSize;
        }
      });
      if (variant) updateLabel(label, variant.inventory_quantity);
    });

    // find inventory of each color in current size
    colorLabels.forEach((label) => {
      const variant = connectedProductVariantData.find((v) => {
        const isSize = v['size'].replaceAll(' ', '-').toLowerCase() == this.options[0]?.replaceAll(' ', '-').toLowerCase() || v['size'].replaceAll(' ', '-').toLowerCase() == this.options[1]?.replaceAll(' ', '-').toLowerCase() || v['size'].replaceAll(' ', '-').toLowerCase() == this.options[2]?.replaceAll(' ', '-').toLowerCase();
        const isColor = v['color'].replaceAll(' ', '-').toLowerCase() == label.dataset.colorNotHandlized.replaceAll(' ', '-').toLowerCase() || v['color'].replaceAll(' ', '-').toLowerCase() == label.dataset.color.replaceAll(' ', '-').toLowerCase();

        return isColor && isSize;
      });
      if (variant) updateLabel(label, variant.inventory_quantity);
    });
  }

  onVariantChange() {
    const _this = this;
    this.updateOptions();

    // MODIFIED: When the user selects a size other than 'none', disable the special initial behavior.
    const selectedSize = this.querySelector('input[name="Size"]:checked')?.value;
    if (this.initialLoadNoParams && selectedSize && selectedSize !== 'none') {
      this.initialLoadNoParams = false;
    }

    this.updateMasterId();
    this.updateVariantStatuses();
    this.updateLowStockNotice();
    this.toggleAddButton(true, '', false, false);
    this.toggleBulkBuyButton();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    //color swatch ?size= referral
    this.updateColorSwatches();
    this.updateInventoryNote();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    if (document.querySelector('.yotpo-reviews-star-ratings-widget')) {
      if (yotpoWidgetsContainer) yotpoWidgetsContainer.initWidgets();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateColorSwatches(size) {
    if (!document.querySelector('.product-colors-links')) {
      return;
    }

    const colorLinks = document.querySelector('.product-colors-links');
    let thisSizeOption;
    if (!size) {
      thisSizeOption = this.optionMap['Size'].values.find((value) => this.options.includes(value)) || '';
    } else {
      thisSizeOption = size;
    }

    colorLinks.querySelectorAll('label').forEach((colorSwatch) => {
      const colorSwatchLink = colorSwatch.querySelector('a');
      const colorSwatchOriginalHref = colorSwatchLink.dataset.originalHref;

      if (thisSizeOption && colorSwatchOriginalHref) {
        colorSwatchLink.setAttribute('href', colorSwatchOriginalHref + '?size=' + encodeURIComponent(thisSizeOption));
      }
    });

    window.dispatchEvent(new CustomEvent('colorSwatchesUpdated', { detail: thisSizeOption }));

  }

  updateMasterId() {
    // Find the variant that matches the selected options
    this.currentVariant = this.getVariantData().find((variant) => {
      // Loop through each option and see if it matches the variant
      return !variant.options
        .map((option, index) => {
          // If the option is empty, it's the default value and should match
          return this.options[index] === option;
        })
        .includes(false); // If any of the options don't match, return false
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (mediaGallery && mediaGallery.setActiveMedia) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // May be absent when the variant's media isn't in this (possibly stale) modal —
    // prepend(null) would insert a stray "null" text node, so guard it.
    if (!newMediaModal) return;
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset?.updateUrl === 'false') return;
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const id = this.currentVariant.id;
    const size = this.currentVariant.option2;
    if (id) params.set('variant', id);
    if (size) params.set('size', size);

    const newURL = `${url.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newURL);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const sectionId = this.dataset.section;
    const productForms = document.querySelectorAll(`#product-form-${sectionId}, #bulk-product-form-${sectionId}, #product-form-installment-${sectionId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const productForm = document.querySelector('.product__info-wrapper product-form.product-form');
    if (productForm) {
      document.dispatchEvent(new CustomEvent('product:size-warning-toggle', {
        detail: { status: false }
      }));
    }
    const currentSize = this.querySelector('input[type="radio"][name="Size"]:checked')?.value;
    const variantElements = [...this.querySelectorAll('.product-form__input input[type="radio"][name="Variant"]')];
    const versions = variantElements.map((v) => v.value);

    for (const version of versions) {
      const foundVariant = this.variantData.find((variant) => {
        return variant.options.includes(version) && variant.options.includes(currentSize);
      });

      if (foundVariant?.available) {
        const variantsEle = this.querySelector(`input[type="radio"][name="Variant"][value="${version}"]`);
        if (!variantsEle?.checked) {
          variantsEle.click();
        }
        break;
      }
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      }
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const originalSection = this.dataset.originalSection;
    const section = this.dataset.section;
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${originalSection ? originalSection : section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${section}`);
        const source = html.getElementById(`price-${originalSection ? originalSection : section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${section}`);
        const color_label = document.getElementById(`Color_label-${section}`);

        if (price) price.classList.remove('visibility-hidden');
        if (color_label) color_label.innerHTML = this.currentVariant.option2;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, modifyText = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const wishlistButton = productForm.querySelector('.klaviyo-bis-trigger');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (modifyText & !wishlistButton) if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (modifyText) addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (wishlistButton) {
      const variantSelected = this.currentVariant && this.currentVariant != 'undefined';
      const variantAvailable = this.currentVariant?.available;

      if (variantSelected && variantAvailable) {
        // Variant selected and available → show add button, hide wishlist
        addButton.classList.remove('hidden');
        wishlistButton.classList.add('hidden');
        document.querySelector('.product-form__submit.pick-size').classList.add('hidden');
        console.log('Variant selected and available');
      } else if (variantSelected && !variantAvailable) {
        // Variant selected but NOT available → show wishlist, hide add button
        addButton.classList.add('hidden');
        wishlistButton.classList.remove('hidden');
        document.querySelector('.product-form__submit.pick-size').classList.add('hidden');
        console.log('Variant selected but NOT available');
      } else {
        // No variant selected → hide both buttons
        console.log('No variant selected');
      }
    }

    if (!modifyClass) return;
  }

  async toggleBulkBuyButton() {
    const section = this.dataset.section;
    const form = document.getElementById(`bulk-product-form-${section}`);
    if (!form) return;
    const productForm = form.closest('product-form');

    if (this.currentVariant.quantity > 0 && this.currentVariant.quantity >= this.currentVariant.bulk_quantity) {
      productForm.classList.remove('d-none');
    } else {
      productForm.classList.add('d-none');
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('#product-variants[type="application/json"]').textContent);
    this.variantQuantity = this.variantQuantity || JSON.parse(this.querySelector('#product-variants-quantity[type="application/json"]').textContent);

    this.variantQuantity.forEach((qtyItem) => {
      const dataItem = this.variantData.find((data) => data.id === qtyItem.id);
      if (dataItem) {
        dataItem.quantity = qtyItem.quantity;
        dataItem.bulk_quantity = qtyItem.bulk_quantity;
      }
    });
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    const variantData = super.getVariantData();
    const isBraOptions = this.dataset.braOptions === 'true';
    this.isBraOptions = isBraOptions;

    if (isBraOptions) {
      this.createBraOptions();
      this.braSizeOptionContainer.classList.remove('visibility-hidden');
      this.braCupOptionContainer.classList.remove('visibility-hidden');
    }

    for (let i = 0; i < variantData.length; i++) {
      if (variantData[i].available) {
        const options = [];
        if (variantData[i].option1) options.push(variantData[i].option1);
        if (variantData[i].option2) options.push(variantData[i].option2);
        if (variantData[i].option3) options.push(variantData[i].option3);

        options.map((option) => {
          let elSize = document.querySelector('[data-size="' + option + '"]');
          elSize?.classList.remove('sold-out');
          elSize?.classList.remove('sold-out-label');
        });
      }
    }
  }

  createBraOptions() {
    this.braSizeOptionContainer = this.querySelector('[data-bra-size]');
    this.braCupOptionContainer = this.querySelector('[data-bra-cup]');
    this.braSizeOptions = this.querySelectorAll('[data-bra-size] .label-group');
    this.braCupOptions = this.querySelectorAll('[data-bra-cup] .label-group');

    this.preparedBraSizeOptions = buildBraOption(this.braSizeOptions, this.braSizeOptionContainer, 'size', /\D/g, sortByNameAlph);
    this.preparedBraCupOptions = buildBraOption(this.braCupOptions, this.braCupOptionContainer, 'cup', /[0-9]/g, sortByNameLex);

    function buildBraOption(braOptions, braOptionContainer, dataset, replaceRegex, sortByCb) {
      // bra sizes text
      braOptions.forEach((braOption) => {
        braOption.querySelector('label').textContent = braOption.querySelector('label').textContent.replace(replaceRegex, '');
        braOption.querySelector('label').dataset[dataset] = braOption.querySelector('label').dataset[dataset].replace(replaceRegex, '');
        braOption.querySelector('input').value = braOption.querySelector('input').value.replace(replaceRegex, '');
      });

      let braOptionSeen = {};
      let braOptionsArray = Array.from(braOptions);
      braOptionsArray = braOptionsArray.sort(sortByCb);

      // remove duplicates
      const braOptionsArrayFiltered = braOptionsArray.filter((braOption) => {
        const txtContent = braOption.querySelector('label').textContent;
        if (braOptionSeen[txtContent]) {
          return false;
        } else {
          braOptionSeen[txtContent] = true;
          return true;
        }
      });

      braOptionsArray.forEach((label) => braOptionContainer.removeChild(label));
      braOptionsArrayFiltered.forEach((label) => braOptionContainer.appendChild(label));

      return braOptionsArrayFiltered;
    }

    // prepare object for storing different size+cup variants
    const variants = JSON.parse(this.querySelector('#product-variants').textContent);
    this.sizeOptionExists = {};
    this.preparedBraSizeOptions.forEach((option) => {
      variants.forEach((variant) => {
        const variantSize = variant.option2.replace(/\D/g, '');
        const variantCup = variant.option2.replace(/[0-9]/g, '');

        this.preparedBraCupOptions.forEach((cupOption) => {
          const sizeOptionSize = option.querySelector('label').dataset.size;
          const cupOptionCup = cupOption.querySelector('label').dataset.cup;

          if (variantCup == cupOptionCup) {
            if (!this.sizeOptionExists[`${sizeOptionSize}`]) {
              this.sizeOptionExists[`${sizeOptionSize}`] = {};
            }

            if (variantSize == sizeOptionSize) {
              this.sizeOptionExists[`${sizeOptionSize}`][cupOptionCup] = {};
              this.sizeOptionExists[`${sizeOptionSize}`][cupOptionCup].exists = true;
              this.sizeOptionExists[`${sizeOptionSize}`][cupOptionCup].available = variant.available;
              this.sizeOptionExists[`${sizeOptionSize}`][cupOptionCup].variant = variant;
            }
          }
        });
      });
    });

    function sortByNameAlph(a, b) {
      return parseInt(a.querySelector('label').textContent.toLowerCase()) - parseInt(b.querySelector('label').textContent.toLowerCase());
    }

    function sortByNameLex(a, b) {
      if (a.querySelector('label').textContent.trim().toLowerCase() < b.querySelector('label').textContent.trim().toLowerCase()) {
        return -1;
      }
      if (a.querySelector('label').textContent.trim().toLowerCase() > b.querySelector('label').textContent.trim().toLowerCase()) {
        return 1;
      }
      return 0;
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    const _this = this;

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });

    if (!this.isBraOptions) {
      return;
    }

    // only for bra options
    this.braChosenSize = this.options[1];
    this.braChosenCup = this.options[2];
    this.options[1] = this.options[1] + this.options[2];
    this.options.pop();

    if (!this.prevBraSizeOptions) this.prevBraSizeOptions = this.preparedBraSizeOptions;
    if (!this.prevBraCupOptions) this.prevBraCupOptions = this.preparedBraCupOptions;

    // reset options to all
    this.prevBraSizeOptions.forEach((option) => this.braSizeOptionContainer.appendChild(option));
    this.prevBraCupOptions.forEach((option) => this.braCupOptionContainer.appendChild(option));

    // add sold out
    let allCupsUnavailable = true;
    Object.keys(this.sizeOptionExists).forEach((sizeJsonOption) => {
      allCupsUnavailable = true;
      Object.keys(this.sizeOptionExists[sizeJsonOption]).forEach((cupJsonOption) => {
        if (this.sizeOptionExists[sizeJsonOption][cupJsonOption].available) {
          allCupsUnavailable = false;
        }
      });

      if (allCupsUnavailable) {
        this.preparedBraSizeOptions.forEach((option) => {
          if (option.querySelector('label').dataset.size == sizeJsonOption) {
            option.querySelector('label').classList.add('sold-out');
            option.querySelector('label').classList.add('sold-out-label');
          }
        });
      }
    });

    // remove unavailable
    if (this.sizeOptionExists[this.braChosenSize]) {
      Object.keys(this.sizeOptionExists[this.braChosenSize]).forEach((cupJsonOption) => {
        // soldout on cups
        this.preparedBraCupOptions.forEach((cupOption) => {
          if (cupOption.querySelector('label').dataset.cup == cupJsonOption) {
            if (this.sizeOptionExists[this.braChosenSize][cupJsonOption].available) {
              cupOption.querySelector('label').classList.remove('sold-out');
              cupOption.querySelector('label').classList.remove('sold-out-label');
            } else {
              cupOption.querySelector('label').classList.add('sold-out');
              cupOption.querySelector('label').classList.add('sold-out-label');
            }
          }

          // if cup doesn't exist remove options
          if (!Object.keys(this.sizeOptionExists[this.braChosenSize]).includes(cupOption.querySelector('label').dataset.cup)) {
            const firstCup = Object.keys(this.sizeOptionExists[this.braChosenSize])[0];

            // select first option if cup option was removed (to prevent undefined cup)
            if (!this.braCupOptionContainer.querySelector('input:checked')) {
              selectFirstOptionLoop: for (const option of this.preparedBraCupOptions) {
                if (option.querySelector('label').dataset.cup == firstCup) {
                  break selectFirstOptionLoop;
                }
              }
            }

            // remove cups
            if (this.braCupOptionContainer.contains(cupOption)) {
              if (cupOption.querySelector('label').dataset.cup == this.braChosenCup) {
                // workaround to prevent unable to select different cups after selected cup option is removed
                cupOption.querySelector('input').checked = false;
                cupOption.closest('.label-group').querySelector('label').click();
                setTimeout(() => {
                  this.braCupOptionContainer.removeChild(cupOption);
                }, 10);
              } else {
                this.braCupOptionContainer.removeChild(cupOption);
              }
            }
          }
        });

        /* remove unavailable sizes
        if (this.braChosenCup) {
          this.preparedBraSizeOptions.forEach(sizeOption => {
            if (!Object.keys(this.sizeOptionExists[sizeOption.querySelector('label').dataset.size]).includes(this.braChosenCup)) {
              if (this.braSizeOptionContainer.contains(sizeOption)) {
                this.braSizeOptionContainer.removeChild(sizeOption);
              }
            }
          })
        }
        */
      });
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class StickyWatcher {
  constructor(selector) {
    this.element = document.querySelector(selector);
    if (!this.element) return;

    this.top = parseInt(getComputedStyle(this.element).top, 10) || 0;

    this.check = this.check.bind(this);

    window.addEventListener('scroll', this.check, { passive: true });
    window.addEventListener('resize', this.check);
    this.check();
  }

  check() {
    if (!this.element) return;

    const rectTop = this.element.getBoundingClientRect().top;
    if (rectTop <= this.top + 50) {
      this.element.classList.add('sticky');
    } else {
      this.element.classList.remove('sticky');
    }
  }
}

new StickyWatcher('.facet-main__wrapper-desktop');
new StickyWatcher('.facet-main__wrapper-mobile');


(function () {
  function init() {
    // 1. Select all target videos
    const videos = document.querySelectorAll('video.promo-text-media');

    // 2. Define the observer options
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.6
    };

    // 3. Define the callback function for the observer
    const handlePlay = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const vid = entry.target;
          // ensure autoplay is allowed on most browsers
          try {
            vid.muted = true;
            vid.playsInline = true;
            vid.setAttribute('muted', '');
            vid.setAttribute('playsinline', '');
          } catch (e) { /* ignore if read-only */ }

          const playPromise = vid.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              console.warn("Autoplay prevented by browser policy:", error);
            });
          }
        }
      });
    };

    // 4. Create the observer
    const observer = new IntersectionObserver(handlePlay, options);

    // small helper to observe a video only once
    const observeVideo = (video) => {
      if (!(video instanceof HTMLVideoElement)) return;
      if (video.__promoObserved) return;
      video.__promoObserved = true;
      // friendly defaults
      video.preload = video.preload || 'auto';
      try { video.muted = true; video.playsInline = true; } catch (e) {}
      observer.observe(video);
      // console.log for quick debug (remove in production)
      console.debug('Observing video.promo-text-media', video);
    };

    // 5. Start observing each existing video
    videos.forEach(observeVideo);

    const mo = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.type !== 'childList') continue;
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('video.promo-text-media')) {
            observeVideo(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('video.promo-text-media').forEach(observeVideo);
          }
        });
      }
    });
    mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  // Run init whether DOMContentLoaded already fired or not (avoids race).
  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }

    
})();

lazyLoadImages();
window.addEventListener('more-content-loaded', lazyLoadImages);

function lazyLoadImages() {
  // 1. Select target images
  const lazyImages = document.querySelectorAll('.card__media img:not(.observed)');

  // 2. Define standard options (optional: rootMargin loads images 200px before they appear)
  const options = {
    root: null, // viewport
    rootMargin: '0px 0px 300px 0px',
    threshold: 0.01 // trigger when 1% of the image is visible
  };

  // 3. Image Observer Callback
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;

        // Swap data-src to src
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }

        // Swap data-srcset to srcset
        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }

        // Optional: Add a class for CSS transitions (e.g., fade-in)
        img.classList.add('observed');

        // Stop observing this image after loading
        observer.unobserve(img);
      }
    });
  }, options);

  // 4. Start observing each image
  lazyImages.forEach(image => {
    imageObserver.observe(image);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initVideoBlocks(), { once: true });
} else {
  initVideoBlocks();
}

document.addEventListener('shopify:section:load', (event) => {
  initVideoBlocks(event.target);
});
